import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams, useNavigate } from "react-router-dom";
import ErrorMessageBox from '../components/ErrorMessageBox';
import { scrollToElement } from '../../lib/userFunctions';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiGetReportTemp, apiStoreReport, apiStoreReportTemp } from './apiBookReport';
import { createFetchErrorMessage } from 'utils/api/Api';
import { toast } from "react-toastify";

export const BookReportForm = ()=>{
    const navigate = useNavigate();
    const { school, isbn } = useParams();
    const [content, setContent] = useState('');
    const auth = useSelector(state => state.auth);
    const queryClient = useQueryClient();

    useEffect(() => scrollToElement('lnb') , []);

    const minContentLength = useMemo(() =>{
        if( auth.grade>=5) return 90;
        if(auth.grade>=3) return 70;
        return 50;
    }, [auth]);

    const onEventPrevent = useCallback((event)=>event.preventDefault(), []);


    // =================== 임시저장 시작 
    const getReportTempApi = useQuery({
        queryKey:['bookreport/temp', isbn], 
        queryFn:apiGetReportTemp,
        refetchOnMount:'always',
    });
    const storeReportTempMutate = useMutation({
        mutationFn:apiStoreReportTemp,
        onSuccess:()=>{
            toast.success( "임시저장 작품은 30일 이후 자동삭제됩니다."  );
            queryClient.invalidateQueries({queryKey:['bookreport/temp', isbn]});
        },
        onError:(err)=>toast.error( createFetchErrorMessage(err).message )
    })
    
    const onSaveTemp = ()=>{
        if(storeReportTempMutate.isPending)return;
        if(!window.confirm("임시저장을 하겠습니까?"))return;
        storeReportTempMutate.mutate({ isbn, content});
    }

    const onLoadTemp = ()=>{
        if(!getReportTempApi.isSuccess) return;
        if(!window.confirm("임시저장을 불러 오겠습니까?"))return;
        setContent(getReportTempApi.data?.data.content);
    }   

    // =================== 임시저장 enddddddddd

    

    const storeReportMutate = useMutation({
        mutationFn:apiStoreReport,
        onSuccess:()=>{
            queryClient.invalidateQueries({queryKey:['bookreport/list', { bestYn:'N', page:0, isbn:'', school:'', user:null }]});
            scrollToElement();
            navigate(`/${school}/bookreport`);
        },
        onError:(err)=>toast.error( createFetchErrorMessage(err).message )
    })

    const onStoreReport = (tmpData)=>{
        if(storeReportMutate.isPending)return;
        if(content===''){
            alert('내용을 입력해주세요.');
            return;
        }
        storeReportMutate.mutate( { isbn, content } );
    }


    const onChangeContent = (event)=>{
        const oldContentLength  = content.length;
        if(event.target.value.length-oldContentLength>10){
            window.location = `/${school}/errorPaste?type=bookreport`;
        }
        setContent(event.target.value);
    }

    const onKeyDown = useCallback((e)=>{
        var ctrlDown = false,
        ctrlKey = 17,
        cmdKey = 91,
        vKey = 86,
        cKey = 67;
        if (e.key === ctrlKey || e.key === cmdKey) ctrlDown = true;
        if (ctrlDown && (e.key === vKey || e.key === cKey)) return false;
    }, []);

       
    if( !auth.grade ) return <ErrorMessageBox message="학년 정보가 없습니다. 학년 등록 후 작성해 주세요." />;
    
    return (
        <div className="section book_report create create_report">
            <div className="guide_box">
                <div className="inner">
                    <div>
                        <ul className="bullet_list">
                            <li>기억에 남는 장면, 나의 생각, 주인공 인터뷰, 뒷이야기 상상 등의 다양한 글을 적어보아요.</li>
                            <li className="warning"><i className="icon fas fa-exclamation-circle"></i> 낙서글과 베끼기의 경우 주의1이 나갑니다. </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="inner">
                <div className="creat_form">
                    <div className="create_report_area">
                        <textarea name="content" className="scrollbar" 
                            rows={10} onChange={onChangeContent} onKeyDown={onKeyDown} value={content} 
                            placeholder={`${auth.grade}학년은\n ${minContentLength}자 이상 써야 저장됩니다. `} 
                            onCopy={onEventPrevent} onCut={onEventPrevent} onPaste={onEventPrevent} onContextMenu={onEventPrevent} />
                        <div className='alignR'>{[...content.replaceAll(/\n/gi, '')].length}자</div>
                    </div>
                    
                    { storeReportMutate.isError && <p className="errorMessage text-center">{createFetchErrorMessage(storeReportMutate.error).message}</p>}

                
                    <div className="cont_row">
                        <div className="create_btn">
                            <div className="bbs_btn alignR">
                                
                                <button className="btn _gray floatL" onClick={onSaveTemp} >{storeReportTempMutate.isPending?'저장중':'임시저장'}</button>
                                { getReportTempApi.isSuccess && getReportTempApi.data?.data && <button className="btn _gray floatL" onClick={onLoadTemp} >불러오기</button> }
                                
                                <button className="btn _turq" onClick={onStoreReport}>{storeReportMutate.isPending?'저장중...':'저장'}</button>
                                <Link to={`/${school}/book/${isbn}/bookreport`} className="btn _red">닫기</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}